<template>
  <div>
    <b-card-title class="data-form pl-3 pt-4">{{ $t("label.detalles.demanda") }}</b-card-title>
    <div>
      <b-row>
        <b-col lg="11" md="11" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col lg="6" md="6">
                  <label class="label-form" for="desCliente">{{ $t("label.cliente") }}</label>
                  <span class="data-form" id="desCliente">
                    {{ transferencia.clientexdelDemanda.cliente.desCliente }}
                  </span>
                </b-col>
                <b-col lg="4" md="4">
                  <label class="label-form" for="desDelegacion">{{ $t("label.delegacion") }}</label>
                  <span class="data-form" id="desDelegacion">
                    {{ transferencia.clientexdelDemanda.delegacion.desDelegacion }}
                  </span>
                </b-col>
                <b-col lg="2" md="2">
                  <label class="label-form" for="divisa">{{ $t("label.divisa") }}</label>
                  <span class="data-form" id="divisa">
                    {{ transferencia.soVDemanda.divisa.simbolo }}
                    {{ transferencia.soVDemanda.divisa.codDivisa }}
                  </span>
                </b-col>
                <b-col
                  v-if="transferencia.soVDemanda.clientexdel.cliente.pais.hasTransportadora"
                  lg="7"
                  md="7"
                >
                  <label class="label-form" for="divisa">{{ $t("label.transportadora") }}</label>
                  <span class="data-form" id="transportadora">{{
                    transferencia.soVDemanda.transportadora.descripcion
                  }}</span>
                </b-col>
              </b-row>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col lg="6" md="6">
                  <label class="label-form" for="fecExpirar">
                    {{ $t("label.fecha.expiracion") }}
                  </label>
                  <span class="data-form" id="fecExpirar">
                    {{ filterDate(transferencia.soVDemanda.fecExpirar) }}
                  </span>
                </b-col>
                <b-col lg="4" md="4">
                  <label class="label-form" for="horaExpiracion">
                    {{ $t("label.hora.expiracion") }}
                  </label>
                  <span class="data-form" id="horaExpiracion">
                    {{ filterTime(transferencia.soVDemanda.fecExpirar) }}
                  </span>
                </b-col>
                <b-col>
                  <label class="label-form" for="coste">{{ $t("label.coste") }}</label>
                  <span class="data-form" id="coste">
                    {{ $t(`label.coste.${transferencia.soVDemanda.coste.codParametro}`) }}
                  </span>
                </b-col>
              </b-row>
              <b-row v-if="isShowBankField" class="pl-4 pr-4 pt-3 pb-3">
                <b-col>
                  <label class="label-form" for="cuentaCorriente">{{
                    $t("label.cuentaCorriente")
                  }}</label>
                  <span class="data-form" id="cuentaCorriente">
                    {{ transferencia.soVDemanda.cuentaCorriente }}
                  </span>
                </b-col>
                <b-col>
                  <label class="label-form" for="agNumeroSucursal">{{
                    $t("label.agNumeroSucursal")
                  }}</label>
                  <span class="data-form" id="agNumeroSucursal">
                    {{ transferencia.soVDemanda.agNumeroSucursal }}
                  </span>
                </b-col>
              </b-row>
              <b-row v-if="isShowBankField" class="pl-4 pr-4 pt-3 pb-3">
                <b-col>
                  <label class="label-form" for="ispbBanco">{{ $t("label.ispbBanco") }}</label>
                  <span class="data-form" id="ispbBanco">
                    {{ transferencia.soVDemanda.ispbBanco }}
                  </span>
                </b-col>
                <b-col>
                  <label class="label-form" for="cnpjPersona">{{ $t("label.cnpjPersona") }}</label>
                  <span class="data-form" id="cnpjPersona">
                    {{ transferencia.soVDemanda.cnpjPersona }}
                  </span>
                </b-col>
              </b-row>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col>
                  <label class="label-form" for="observaciones">
                    {{ $t("label.observaciones") }}
                  </label>
                  <span class="data-form" id="observaciones">
                    {{ transferencia.soVDemanda.observaciones }}
                  </span>
                </b-col>
              </b-row>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col lg="6" md="6">
                  <label class="label-form" for="checkParcial">{{ $t("label.parcial") }}</label>
                  <span
                    class="data-form"
                    id="checkParcial"
                    v-if="transferencia.soVDemanda.checkParcial"
                  >
                    {{ $t("label.si") }}
                  </span>
                  <span class="data-form" id="checkParcial" v-else>{{ $t("label.no") }}</span>
                </b-col>
                <b-col v-if="transferencia.clientexdelDemanda.cliente.pais.hasTasa">
                  <label class="label-form" for="tasa">{{ $t("label.tasa") }}</label>
                  <span
                    v-if="!transferencia.clientexdelDemanda.cliente.pais.hasTasaEnteros"
                    class="data-form"
                    id="tasa"
                  >
                    {{ filterNumber(transferencia.soVDemanda.numTasa, 5) }} %
                  </span>
                  <span
                    v-if="transferencia.clientexdelDemanda.cliente.pais.hasTasaEnteros"
                    class="data-form"
                    id="tasa"
                  >
                    {{ Math.round(transferencia.soVDemanda.numTasa * 100000) }} x 10.000
                  </span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-card-title class="label-form pl-2 pr-4 pt-3 pb-2">{{
                $t("label.demandas")
              }}</b-card-title>
              <template v-for="detalle in transferencia.soVDetalleTransferencias">
                <b-row class="pl-2 pb-3" :key="detalle.id" v-if="detalle.cantidadDemandada > 0">
                  <b-col lg="6" md="6">
                    <label class="label-form" :for="`denominacion_${detalle.id}`">
                      {{ $t("label.denominacion") }}
                    </label>
                    <span class="data-form" :id="`denominacion_${detalle.id}`">
                      {{ detalle.soCalidadDenominacion.denominacion.codDenominacion }}
                      {{ detalle.soCalidadDenominacion.desCalidad }}</span
                    >
                  </b-col>
                  <b-col>
                    <label class="label-form" :for="`demandado_${detalle.id}`">
                      {{ $t("label.demandado") }}
                    </label>
                    <span class="data-form" :id="`demandado_${detalle.id}`">
                      {{ transferencia.soVDemanda.divisa.simbolo }}
                      {{ filterNumber(detalle.cantidadDemandada, 2) }}
                    </span>
                  </b-col>
                </b-row>
              </template>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ITransferencia } from "@/entities";
import VueFilters from "@/vue-filters";

@Component({
  name: "detalle-demanda",
  mixins: [VueFilters],
})
export default class TransferenciaDetalle extends Vue {
  @Prop({ required: true }) transferencia!: ITransferencia;
  isShowBankField = false;
  public fecha = "";

  mounted(): void {
    this.isShowBankField = this.transferencia.soVDemanda.clientexdel.cliente.pais.hasInfoBancaria;
    this.fecha = this.filterDate(this.transferencia.fecExpirar);
  }
}
</script>

<style lang="scss" scoped>
.recent-label {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 30px;
  letter-spacing: normal;
  color: var(--secundario-prosegur-claro);
}
.label-form {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--secundario-prosegur-oscuro-plus-10);
  margin-bottom: 0;
}
.data-form {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: var(--secundario-prosegur-claro);
  text-transform: initial;
}

.btn-number {
  border-color: transparent;
  background-color: rgba(0, 0, 0, 0.03);
}

.card {
  margin: 0 0 0 0.75rem;
}

.card span {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}

.card span:hover {
  white-space: normal;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

.move-panel {
  transition: all 1.5s ease-in-out;
  transform: translate(-25vw, 0);
}
</style>
